@if(isportal){

<div id="main-layout">
    <main class="w-full">
        <p-toast position="top-right" appendTo="body"></p-toast>
        <router-outlet></router-outlet>
    </main>
</div>

} @else {

<div id="main-layout" class="layout-sidemenu" [class.sidenav-toggled]="!isSidemenuOpen">

    <div class="layout-sidemenu__nav" *ngIf="isloggedIn && showSidebar">
        <app-sidemenu></app-sidemenu>
    </div>

    <main [class.layout-sidemenu__content]="showSidebar" [class.w-full]="!showSidebar">
        <p-toast position="top-right" appendTo="body"></p-toast>
        <router-outlet></router-outlet>
    </main>

</div>

}